import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0); // Scorri in cima alla pagina
  }, [pathname]); // Esegui l'effetto quando cambia il percorso

  return null;
};

export default ScrollToTop;
